import styled, { css } from "styled-components";
import { ReactComponent as Check } from "../../../app/newLayout/assets/svgIcon/listView/CheckForFilter.svg";
import { ReactComponent as Close } from "../../../app/newLayout/assets/svgIcon/listView/Close.svg";
import { ReactComponent as FilterIcon } from "../../../app/newLayout/assets/svgIcon/listView/filter.svg";
import { ReactComponent as Search } from "../../../app/newLayout/assets/svgIcon/listView/search.svg";
import { ReactComponent as UpDown } from "../../../app/newLayout/assets/svgIcon/listView/UpDown.svg";

export const StyledIconCss = css`
  cursor: pointer;
  height: 16px;
  width: 16px;

  & path,
  & circle,
  & rect {
    fill: currentColor;
  }

  &.for-table-header {
    height: 12px;
    width: 12px;
    flex: 0 0 auto;
  }
`;

export const StyledCheckIconSVG = styled(Check)`
  ${StyledIconCss};
`;

export const StyledCloseIconSVG = styled(Close)`
  ${StyledIconCss};

  &.bulk-field-error {
    height: 14px;
    position: absolute;
    right: 10px;
    top: 10px;
    width: 14px;
  }

  &.for-clear-header-filter:hover {
    color: var(--CLOUD, #fcfdfe);
  }
`;

export const StyledFilterIconSVG = styled(FilterIcon)`
  ${StyledIconCss};
`;

export const StyledSearchIconSVG = styled(Search)`
  ${StyledIconCss};
`;

export const StyledUpDownIconSVG = styled(UpDown)`
  ${StyledIconCss};

  &.for-table-header.active {
    color: var(--DARK-BLUE, #1249bf);
  }
`;
